// @flow

const captureClientIdFromBkWebAppPath = /^\/app\/(\d+)/;

const getClientId = () => {
  if (typeof window === 'undefined' || !window.location) {
    throw new Error('getClientId was called in a context without access to `window.location`');
  }
  const pathnameMatch = window.location.pathname.match(captureClientIdFromBkWebAppPath);
  return pathnameMatch && pathnameMatch[1];
};

export default getClientId;
